import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 87 16',
}) => (
  <svg
    width={width}
    style={style}
    height="16"
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M20.006,128.219l-.464.442a.725.725,0,0,0,0,1.061l5.511,5.215H-57.212a.77.77,0,0,0-.788.75v.625a.77.77,0,0,0,.788.75H25.053l-5.511,5.215a.725.725,0,0,0,0,1.061l.464.442a.817.817,0,0,0,1.114,0l7.649-7.25a.725.725,0,0,0,0-1.061l-7.649-7.25A.816.816,0,0,0,20.006,128.219Z"
          transform="translate(58 -128)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
